import { Form } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
//icons
import { BsSearch } from 'react-icons/bs';
//constants
import { choicesSearch, getContentProduct } from 'constants';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input/index.js';


const FiltersTableProducts = ({ formFilter, setFormFilter, handleClear, t, page, setPage }) => {
  const contenidos = getContentProduct(t, true);
  const [localFilters, setLocalFilters] = useState({
    titulo: formFilter.titulo || '',
    ean: formFilter.ean || '',
  });
  const debounceRef = useRef(null);

  useEffect(() => {
    setLocalFilters({
      titulo: formFilter.titulo || '',
      ean: formFilter.ean || '',
    });

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [formFilter.titulo, formFilter.ean]);

  const handleSearch = (value, key, { debounce = true } = {}) => {
    setLocalFilters((prev) => ({ ...prev, [key]: value }));
    if (page > 1 && value !== '') setPage(1);
    if (!debounce) {
      setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: value }));
      return;
    }
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const meetsLength = value.length === 0 || value.length >= 3;
      if (meetsLength) {
        setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: value }));
      }
    }, 300);
  };

  return (
    <SearchTable multipleInput={true} handleClear={handleClear}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          placeholder={t('titulo')}
          value={localFilters.titulo}
          label={t('titulo')}
          onChange={(e) => handleSearch(e, 'titulo')}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          placeholder={t('ean')}
          value={localFilters.ean}
          label={t('ean')}
          onChange={(e) => handleSearch(e, 'ean')}
        />
        <SelectInputCustom
          choices={contenidos}
          label={t('product.producttype')}
          onCheckedItem={(e) => handleSearch(e, 'type', { debounce: false })}
          value={formFilter.type}
        />
      </Form>
    </SearchTable>
  );
};

FiltersTableProducts.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTableProducts;
